//ggrop La unica configuracion que hay q cambiar para que funcione el proyecto es:
//   window.location.protocol + "//" +  window.location.hostname + ":8000";
let server =

window.location.protocol + "//" +  window.location.hostname; // + ":8000";

let urlv1 = server + "/api/v1";
let urlv2 = server + "/api/v2";

let auth = server + "/dj-rest-auth";

let config = {
  server: server,
  apiv1: urlv1,
  apiv2: urlv2,
  api_carreras: urlv1 + "/carreras",
  api_acreditaciones: urlv1 + "/acreditaciones",
  api_alumnos_basico: urlv1 + "/alumnos",
  api_personas: urlv1 + "/personas",
  api_login: auth + "/login/",
  api_logout: auth + "/logout/",
  api_documentacion: urlv1 + "/documentos",
  api_localidad: urlv1 + "/localidad",
  api_provincia: urlv1 + "/provincia",
  api_pais: urlv1 + "/paises",
  api_documento: urlv1 + "/tipo_documento",
  api_titulos: urlv1 + "/personas_titulos",
  api_preinscriptos: urlv1 + "/pre_inscriptos",
};

export { config };
